var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.25rem",
    height: "1.25rem",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eqx6nmqqca"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 552",
    style: {
      strokeWidth: ".5px"
    },
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61678"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11267",
    style: {
      clipPath: "url(#eqx6nmqqca)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11266"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5821",
    d: "M707.239 527.823v7.82a1.807 1.807 0 0 1-1.927 1.946q-6.553.006-13.106 0a1.8 1.8 0 0 1-1.919-1.915q-.006-3.669 0-7.336v-.5c-.164.151-.274.25-.381.354-.357.346-.716.389-1 .115s-.25-.648.095-.995q.983-.988 1.97-1.97 2.8-2.8 5.605-5.6a2.912 2.912 0 0 1 4.377.006q3.748 3.742 7.493 7.49a2.479 2.479 0 0 1 .215.227.608.608 0 0 1-.054.85.588.588 0 0 1-.82.03c-.172-.145-.321-.305-.548-.522zm-5.338 8.509h3.393c.492 0 .686-.195.686-.691q0-4.412-.006-8.825a.688.688 0 0 0-.177-.439q-2.9-2.923-5.823-5.828a1.623 1.623 0 0 0-2.436.011q-2.906 2.893-5.794 5.8a.732.732 0 0 0-.194.471q-.017 4.393-.008 8.785c0 .522.189.713.7.715h3.1a2.492 2.492 0 0 0 .276-.032v-.45c0-1.477-.008-2.955 0-4.431a1.952 1.952 0 0 1 1.989-1.987c.771-.007 1.543-.009 2.315 0a1.949 1.949 0 0 1 1.971 1.965c.011 1.176 0 2.352 0 3.53zm-1.259-.016c0-1.671.006-3.3 0-4.934a.681.681 0 0 0-.739-.7c-.705-.009-1.411 0-2.116 0-.664 0-.9.236-.9.89v4.743z",
    transform: "translate(-688.808 -518.124)",
    style: {
      strokeWidth: ".5px"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.749e294da5a5e98dcb6137dc941ffaf8.svg";
export { ForwardRef as ReactComponent };